var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentageLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69839",
    "data-name": "Group 69839",
    transform: "translate(-630.005 -449)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Handle",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(630.005 449)",
    fill: "#212750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42719",
    "data-name": "Path 42719",
    d: "M3.088-6.544C4.464-6.544,5.04-7.6,5.04-8.96c0-1.376-.592-2.432-1.952-2.432C1.7-11.392,1.12-10.336,1.12-8.96,1.12-7.6,1.7-6.544,3.088-6.544Zm0-.848c-.752,0-1.024-.624-1.024-1.568,0-.96.272-1.584,1.024-1.584.736,0,1.008.624,1.008,1.584C4.1-8.016,3.824-7.392,3.088-7.392ZM1.92-1.7,8.752-8.8l-.768-.7L1.152-2.4ZM6.832.144c1.376,0,1.952-1.056,1.952-2.432S8.192-4.7,6.832-4.7c-1.392,0-1.968,1.04-1.968,2.416S5.44.144,6.832.144Zm0-.848c-.752,0-1.024-.64-1.024-1.584S6.08-3.856,6.832-3.856c.736,0,1.008.624,1.008,1.568S7.568-.7,6.832-.7Z",
    transform: "translate(637.005 467)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageLight);
export default __webpack_public_path__ + "static/media/percentage-light.d33b777b8c9233e363b4932a6794cad5.svg";
export { ForwardRef as ReactComponent };